import type { Feedback } from '../types'

import { useState } from 'react'

import { useCloseModal, useModalController, useConfigureModalController } from '@/atoms'

type ModalState = 'ready' | 'submitting' | 'error'

interface ModalData {
  feedback: Feedback
}

export const modalId = 'giveFeedback'

export const useController = () => useModalController<ModalData, ModalState>(modalId)

export const useConfigureController = () => {
  const close = useCloseModal()

  // INITIALIZATION
  const [options] = useState(() => ({
    createInitialState: () => ({
      close,
      data: {
        feedback: {
          message: '',
        },
      },
    }),
  }))

  const ctrl = useConfigureModalController<ModalData, ModalState>(modalId, options)

  return ctrl
}
